import type { ClickstreamPayload } from '@zg-rentals/clickstream';

export enum UserType {
  Renter = 'renter',
  Landlord = 'landlord',
}

export enum ReportType {
  LegacyCreditReport = 'legacyCreditReport',
  LegacyBackgroundReport = 'legacyBackgroundReport',
  CreditReport = 'creditReport',
  BackgroundReport = 'backgroundReport',
}

export type RentalApplicationAddress = {
  city?: string;
  state?: string;
  street?: string;
  unit?: string;
  zip?: string;
};

export interface ApplicationData {
  applicationId: string;
  stateCode: string;
  city: string;
  applicantFirstName: string;
  numberOfApplicants: number;
}

export interface TrackEvent {
  (clickstreamEvent: ClickstreamPayload): void;
}

export interface EmitMetric {
  (metricName: string): void;
}

export type ConditionallyApprove = (() => Promise<boolean>) | undefined;

export enum LogLevel {
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

export interface LogData {
  message: string;
  error?: unknown;
}

export interface Log {
  (logLevel: LogLevel, logData: LogData): void;
}
